module.exports = __webpack_public_path__ + "img/mono-square.22d1e89f.svg";